<style scoped lang="less">
@import 'modal.less';

.modal-item {
  .modal-item-base();
}
</style>
<template>
  <!-- 绑定邮箱模态框 - 开始 -->
  <Modal
    v-model="vis"
    :loading="true"
    :mask-closable="false"
    :title="$t('绑定手机')"
  >
    <el-form ref="formRef" :model="formData" :rules="rules">
      <el-form-item prop="phone" class="phone-item">
        <div class="phone-wrapper">
          <div class="country-box">
            <div class="tips">{{ $t('国家') }}</div>
            <Select v-model="formData.areaCode" size="large">
              <Option
                v-for="item in countryList"
                :key="item.id"
                :value="item.areaCode"
                :label="item.name"
              />
            </Select>
          </div>
          <div class="phone-box">
            <div class="tips">{{ $t('手机号码') }}</div>
            <el-input
              v-model="formData.phone"
              size="large"
              :placeholder="$t('请输入手机号码')"
            />
          </div>
        </div>
      </el-form-item>

      <el-form-item prop="code">
        <div class="tips">{{ $t('短信验证码') }}</div>
        <div class="code-box">
          <el-input
            v-model="formData.code"
            size="large"
            :placeholder="$t('请输入短信验证码')"
          />
          <verify-code
            ref="verifyCodeRef"
            :rebase="vis"
            @click="getCode"
          ></verify-code>
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="vis = false">{{ $t('取消') }}</el-button>
      <el-button type="primary" :loading="loading" @click="bindEmailHandle">{{
        $t('确定')
      }}</el-button>
    </template>
  </Modal>
  <!-- 绑定邮箱模态框 - 结束 -->
</template>

<script>
import ModalBase from '@/components/ModalBase'
import { ajax_sendSms, ajax_bindEmail, ajax_getContry } from '@/api/personal'
import { ajaxSmsHandle, updateUserInfo } from '@/utils'

export default {
  name: 'EmailModal',
  extends: ModalBase,
  data() {
    return {
      countryList: [],
      formData: {
        phone: '',
        code: '',
        areaCode: '+86'
      },
      rules: {
        phone: [
          {
            required: true,
            message: this.$t('请输入手机号码'),
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: this.$t('请填写手机验证码！'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  async mounted() {
    this.countryList = await ajax_getContry()
  },
  methods: {
    getCode(e) {
      this.$refs.formRef.validateField('phone', async (validateRes) => {
        if (validateRes) {
          e.sendFail()
          return
        }
        ajaxSmsHandle(
          ajax_sendSms({
            account: this.formData.phone,
            type: 'bandingMobile',
            areaCode: this.formData.areaCode
          }),
          e
        )
      })
    },
    async bindEmailHandle() {
      await this.$refs.formRef.validate()
      // 确认绑定邮箱
      this.loading = true
      try {
        await ajax_bindEmail(this.formData)
        this.$Message.success(this.$t('操作成功'))
        await updateUserInfo()
        this.vis = false
      } finally {
        this.loading = false
      }
    }
  },
  watch: {}
}
</script>
<style lang="less" scoped>
.tips {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-bottom: 10px;
}
.phone-item {
  .phone-wrapper {
    display: flex;
    .country-box {
      width: 100px;
      margin-right: 10px;
    }
    .phone-box {
      flex: 1;
    }
  }
  ::v-deep {
    .el-form-item__error {
      left: 110px;
    }
  }
}

.code-box {
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}
</style>
